import React, { useState, useContext } from 'react';
import { CartContext } from '../../contexts/CartContext';
import { formatNumber } from '../../helpers/utils';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Collapse } from 'react-bootstrap';

const ProductItem = ({product}) => {
    const [open, setOpen] = useState(false);
    const { addProduct, cartItems, increase, removeProduct } = useContext(CartContext);

    const isInCart = product => {
        return !!cartItems.find(item => item.id === product.id);
    }

    return ( 
        <div className="card card-body">
            <img style={{display: "block", margin: "0 auto 10px", maxHeight: "200px"}} className="img-fluid" 
            src={product.photo + '?v=' + product.id} alt=""/>
            <p>{product.name}</p>
            <p style={{fontWeight:"bold"}}>{product.author}</p>
            <Collapse in={open}>
                <div id="collapse"> 
                    {product.resume}
                </div>
            </Collapse>
            <h3 className="text-left">{formatNumber(product.price)}</h3>
            <div className="text-right">
                <Button className="btn btn-info btn-sm mr-2"
                    onClick={() => setOpen(!open)}
                    aria-controls="collapse"
                    aria-expanded={open}>
                Détails
                </Button>
              
              
                {
                    isInCart(product) && 
                    <button 
                    onClick={() => increase(product)}
                    className="btn btn-outline-primary btn-sm">Ajouter</button>
                }

                {
                    !isInCart(product) && 
                    <button 
                    onClick={() => addProduct(product)}
                    className="btn btn-primary btn-sm">Ajouter au panier</button>
                }

                <button 
                onClick= {() => removeProduct(product)} 
                className="btn btn-primary btn-sm" style={{margin: "1px"}}> X </button>
                
            </div>
        </div>
     );
}
 
export default ProductItem;